import { useQuery } from '@apollo/client';
import {
  CurrentUserPackagesResponse,
  GET_CURRENT_USER_PACKAGES,
} from '@/features/Profile/sections/Packages/api';

export function useCurrentUserPackages() {
  const isBrowser = typeof window !== 'undefined';
  const { data, loading } = useQuery<CurrentUserPackagesResponse>(
    GET_CURRENT_USER_PACKAGES,
    {
      skip: !isBrowser,
      fetchPolicy: 'cache-and-network',
    }
  );

  return {
    packages: data?.currentUserPackages?.nodes ?? [],
    loading,
  };
}
